import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classNames from 'classnames';
import { ITEM_EVENT, FAVORITES, FOLLOWING } from './favNotificationsConstants';
import { showAlert } from './favNotificationsHelpers.es';
import style from './FavNotificationsTile-style.scss';

/*
 * Formats date string to MMM DD and if day number is one digit removes `0` in front, f.e. Jan 1
 */
const formatDate = date => date ? new Date(date).toDateString().match(' (.*) ')[1].replace(' 0', ' ') : '';

const messages = {
    [ITEM_EVENT]: {
        header: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileHeader.item_event_header'
                defaultMessage='Item Status'
            />
        )
    },
    [FAVORITES]: {
        header: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileHeader.favorites_header'
                defaultMessage='Recently Saved'
            />
        )
    },
    [FOLLOWING]: {
        header: (
            <FormattedMessage
                id='dbl.Header.FavNotificationsTileHeader.following_header'
                defaultMessage='New Arrivals:'
            />
        )
    }
};

const FavNotificationsTileHeader = ({ tile }) => {
    const { type, name, createdDate } = tile;
    const staticContent = messages[type] || {};
    const headerClasses = classNames(style.header, {[style.headerAlert]: showAlert(tile)});

    return (
        <div className={headerClasses}>
            <div className={style.headerText}>{staticContent.header}</div>
            {name && <div className={style.headerTitleName}>{name}</div>}
            {createdDate && <div className={style.headerDate}>{formatDate(createdDate)}</div>}
        </div>
    );
};

FavNotificationsTileHeader.propTypes = {
    tile: PropTypes.object.isRequired
};

export default createFragmentContainer(FavNotificationsTileHeader, {
    tile: graphql`
        fragment FavNotificationsTileHeader_tile on FavoriteNotification {
            type
            name
            createdDate
            lastViewedDate
        }
    `
});



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotificationsTileHeader.jsx